import React from 'react';
import type { UserWithConfig } from '../../../services/adminService';

type AdminPageDeleteUserModalProps = {
  user: UserWithConfig;
  confirmValue: string;
  onConfirmValueChange: (v: string) => void;
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
  canConfirm: boolean;
};

const AdminPageDeleteUserModal: React.FC<AdminPageDeleteUserModalProps> = ({
  user,
  confirmValue,
  onConfirmValueChange,
  onClose,
  onConfirm,
  loading,
  canConfirm,
}) => (
  <div className="admin-page-modal-overlay">
    <div className="admin-page-modal admin-page-modal-lg">
      <div className="admin-page-modal-header">
        <div>
          <h3 className="admin-page-modal-title">Delete User</h3>
          <p className="admin-page-modal-subtitle">This action cannot be undone. Type the user's email to confirm.</p>
        </div>
        <button type="button" onClick={onClose} className="admin-page-modal-close" aria-label="Close delete dialog">
          ✕
        </button>
      </div>

      <div className="admin-page-modal-body space-y-4">
        <div className="admin-page-modal-user-box">
          <p className="admin-page-modal-label">User</p>
          <p className="admin-page-modal-user-name">{user.user.name || 'No Name'}</p>
          <p className="admin-page-modal-user-email">{user.user.email}</p>
        </div>

        <div>
          <label className="admin-page-modal-label-block">
            Type <span className="text-white font-semibold">{user.user.email}</span> to confirm
          </label>
          <input
            type="text"
            value={confirmValue}
            onChange={(e) => onConfirmValueChange(e.target.value)}
            className="admin-page-modal-input"
            placeholder="user@example.com"
            autoFocus
          />
        </div>

        <div className="admin-page-delete-warning">
          <p className="admin-page-delete-warning-title">The following data will be permanently removed:</p>
          <ul className="admin-page-delete-warning-list">
            <li>All runs and leads</li>
            <li>Inbound configurations, logs, and matching rules</li>
            <li>Assistant configuration</li>
            <li>Credit transactions and reserves</li>
          </ul>
        </div>
      </div>

      <div className="admin-page-modal-actions">
        <button type="button" onClick={onClose} className="admin-page-modal-btn admin-page-modal-btn-cancel" disabled={loading}>
          Cancel
        </button>
        <button
          type="button"
          onClick={onConfirm}
          disabled={!canConfirm || loading}
          className={`admin-page-modal-btn admin-page-modal-btn-confirm ${canConfirm && !loading ? 'admin-page-modal-btn-danger' : 'admin-page-modal-btn-disabled'}`}
        >
          {loading ? (
            <>
              <span className="admin-page-modal-spinner" />
              Deleting…
            </>
          ) : (
            'Delete User'
          )}
        </button>
      </div>
    </div>
  </div>
);

export default AdminPageDeleteUserModal;
